module.exports = __webpack_public_path__ + "static/img/MelbourneMavericks.58a4ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MelbourneMavericks.png
// module id = E+Ih
// module chunks = 1